import SubmittedDocPreviewInput from '@/components/SubmittedDocPreviewInput.vue'
import { createInput } from '@formkit/vue'
export const submittedDocPreviewInput = createInput(SubmittedDocPreviewInput, {
  props: ['docType', 'changeRequestId', 'workspaceId']
})
